import { BsEyeFill } from "react-icons/bs";
import styled from "styled-components";

import { Column22, Container, EmptyText, Row1, SectionTitle } from "pages/home/components/Layout";
import { Thumbnail } from "shared/ui/media";

/**
 *  고정 공지글 조회수 섹션
 */
export const FixedNoticeCountSection = ({ notices, gotoNoticeDetail }) => {
  const pinnedNotices = notices
    .filter((data) => data.pin === true && data.hide === false)
    .slice(0, 4);
  const toPreviewText = (html) =>
    String(html || "")
      .replace(/<[^>]+>/g, " ")
      .replace(/\s+/g, " ")
      .trim();

  return (
    <Row1>
      <Column22>
        <SectionTitle $left={0}>고정 공지글 조회수</SectionTitle>
        <Container
          $height={252}
          $top={14}
          $bottom={182}
          style={{
            background: "transparent",
            padding: 0,
            alignItems: "stretch",
          }}
        >
          <NoticeBanner onClick={() => gotoNoticeDetail(notices)}>
            {pinnedNotices.length === 0 ? (
              <EmptyState>
                <EmptyText $left={0}>등록된 공지가 없습니다.</EmptyText>
              </EmptyState>
            ) : (
              <NoticeGrid>
                {pinnedNotices.map((data) => (
                  <NoticeCard
                    key={`fixed_notice_${data.id ?? data.createdAt ?? data.title}`}
                  >
                    <NoticeThumbFrame>
                      <Thumbnail
                        src={data.image}
                        alt={data.title}
                        size="100%"
                        radius="0"
                        bordered={false}
                      />
                    </NoticeThumbFrame>
                    <NoticeTextWrap>
                      <NoticeTitle>{data.title}</NoticeTitle>
                      <NoticeExcerpt>{toPreviewText(data.content)}</NoticeExcerpt>
                      <NoticeView>
                        <EyeIcon />
                        <span>{data.viewCnt ?? 0}</span>
                      </NoticeView>
                    </NoticeTextWrap>
                  </NoticeCard>
                ))}
              </NoticeGrid>
            )}
          </NoticeBanner>
        </Container>
      </Column22>
    </Row1>
  );
};

const NoticeBanner = styled.div`
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 10px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 0;
`;

// 공지가 없을 때 안내 문구를 배너 전체 영역의 정가운데에 배치한다.
const EmptyState = styled.div`
  flex: 1;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const NoticeGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-template-rows: repeat(2, 100px);
  column-gap: 10px;
  row-gap: 30px;
  overflow: hidden;
  flex: 1;
  min-height: 0;
  width: 100%;
  height: 100%;
  justify-content: start;
  align-content: center;
`;

const NoticeCard = styled.div`
  width: 100%;
  height: 100px;
  border: none;
  border-radius: 0;
  display: flex;
  align-items: stretch;
  overflow: hidden;
  min-height: 0;
`;

const NoticeThumbFrame = styled.div`
  height: 100%;
  aspect-ratio: 1 / 1;
  flex-shrink: 0;
  background: #f2f4f8;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  border-radius: 0;
  overflow: hidden;
`;

const NoticeTextWrap = styled.div`
  padding: 0 10px 8px 10px;
  min-width: 0;
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 0;
`;

const NoticeTitle = styled.div`
  font-family: "Noto Sans KR";
  font-size: 12px;
  font-weight: 700;
  line-height: 140%;
  color: #111;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-height: 17px;
`;

const NoticeExcerpt = styled.div`
  font-family: "Noto Sans KR";
  font-size: 11px;
  line-height: 145%;
  color: #4a5563;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  min-height: 32px;
  max-height: 32px;
`;

const NoticeView = styled.div`
  font-family: "Noto Sans KR";
  font-size: 11px;
  color: #0b589a;
  display: flex;
  align-items: center;
  gap: 4px;
  min-height: 14px;
`;

const EyeIcon = styled(BsEyeFill)`
  font-size: 12px;
`;
